import { type ReactNode } from 'react';
import { Check, X } from 'lucide-react';
import { cn } from '@/nucleo/utilitarios';

interface DoDontProps {
  doTitle?: string;
  dontTitle?: string;
  doText: string;
  dontText: string;
  doExample?: ReactNode;
  dontExample?: ReactNode;
  className?: string;
}

export function DoDont({
  doTitle = 'Faça',
  dontTitle = 'Não faça',
  doText,
  dontText,
  doExample,
  dontExample,
  className,
}: DoDontProps) {
  return (
    <div className={cn('grid gap-3 sm:grid-cols-2 break-inside-avoid', className)}>
      <Panel tone="success" icon={<Check className="h-3.5 w-3.5" />} title={doTitle} text={doText}>
        {doExample}
      </Panel>
      <Panel
        tone="destructive"
        icon={<X className="h-3.5 w-3.5" />}
        title={dontTitle}
        text={dontText}
      >
        {dontExample}
      </Panel>
    </div>
  );
}

function Panel({
  tone,
  icon,
  title,
  text,
  children,
}: {
  tone: 'success' | 'destructive';
  icon: ReactNode;
  title: string;
  text: string;
  children?: ReactNode;
}) {
  return (
    <div
      className={cn(
        'rounded-xl border bg-card p-4',
        tone === 'success' ? 'border-success/40' : 'border-destructive/40',
      )}
    >
      <div className="flex items-center gap-2 mb-2">
        <span
          className={cn(
            'inline-flex h-5 w-5 items-center justify-center rounded-full',
            tone === 'success'
              ? 'bg-success text-success-foreground'
              : 'bg-destructive text-destructive-foreground',
          )}
        >
          {icon}
        </span>
        <span className="text-xs font-semibold uppercase tracking-wider text-foreground">
          {title}
        </span>
      </div>
      <p className="text-xs text-muted-foreground leading-relaxed">{text}</p>
      {children && <div className="mt-3 pt-3 border-t border-border/60">{children}</div>}
    </div>
  );
}
